function bindThumbnailsColorbox() {
    $('.thumbnail').colorbox({
        rel: 'gal', title: function () {
            var url = $(this).attr('href');
            var title = $(this).attr('title');
            return '<strong>' + title + '</strong>';
        }
    });
}
bindThumbnailsColorbox();
